import { ButtonHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import s from './ActionButton.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement | HTMLDivElement> {
  purple?: boolean;
  isLine?: boolean;
  isDivElement?: boolean;
}

export const ActionButton = ({ children, className, isLine, purple, disabled, isDivElement, ...props }: Props) => {

  return isDivElement ? (
    <div
      className={clsx(s.button, className, {
        [s.button_purple]: purple,
        [s.button_line]: isLine,
        [s.button_disabled]: disabled,
      })}
      {...props}
    >
      {children}
    </div>
  ) : (
    <button
      className={clsx(s.button, className, {
        [s.button_purple]: purple,
        [s.button_line]: isLine,
        [s.button_disabled]: disabled,
      })}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};